import { Box } from '@gluestack-ui/themed';

export default function BottomSheetFooter(props) {
  return (
    <Box {...props} w={'$full'}>
      {props?.children}
    </Box>
  );
}
